// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2199S","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__3SEe3"};